<template>
  <div class="container">
    <el-page-header class="page-header" @back="goBack" :content="title">
    </el-page-header>
    <div class="main">
      <el-form ref="ruleForm" :model="form" :rules="rules" label-width="12.0rem">
        <div class="form-header">
          <el-form-item prop="scope" label="成员：">
            <el-radio-group v-model="form.scope" @change="changeScope">
              <el-radio :label="1">通用</el-radio>
              <el-radio :label="2">仅部分客服适用</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="form.scope === 2" label="添加成员：" prop="userid">
            <div class="person">
              <el-tag v-for="item of names" :key="item" effect="plain"  style="margin-right: 1.2rem">
                {{ item }}
              </el-tag>
            </div>
            <el-button class="addBtn" icon="el-icon-plus" @click="addContact">前往添加</el-button>
          </el-form-item>
        </div>
        <div class="form-content">
          <el-form-item prop="type" label="发送类型：">
            <el-radio-group v-model="form.type" @change="changeType">
              <el-radio label="文本消息">文本消息</el-radio>
              <el-radio label="菜单消息">菜单消息</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item prop="types" v-if="form.type === '菜单消息'" label="菜单类型：">
            <el-checkbox-group v-model="checkList" @change="changeGroup">
              <el-checkbox label="回复菜单"></el-checkbox>
              <el-checkbox label="超链接菜单"></el-checkbox>
              <el-checkbox label="小程序菜单"></el-checkbox>
            </el-checkbox-group>
          </el-form-item>

          <el-form-item prop="content" key="content" v-if="form.type === '文本消息'" label="文本内容：">
            <el-input clearable type="textarea" autosize="true" placeholder="请输入内容（不能超过500字）" v-model="form.content"></el-input>
          </el-form-item>
          <el-form-item prop="click_content" v-if="checkList.includes('回复菜单')" label="回复菜单：">
            <el-input clearable v-model="form.click_content" placeholder="请输入回复菜单内容（不能超过30字）"></el-input>
          </el-form-item>
          <el-form-item prop="view_url" v-if="checkList.includes('超链接菜单')" label="超链接：">
            <el-input clearable v-model="form.view_url" placeholder="请输入超链接"></el-input>
          </el-form-item>
          <el-form-item prop="view_content" v-if="checkList.includes('超链接菜单')" label="超链接菜单：">
            <el-input clearable v-model="form.view_content" placeholder="请输入超链接菜单内容（不能超过200字）"></el-input>
          </el-form-item>
          <el-form-item
            prop="miniprogram_appid"
            v-if="checkList.includes('小程序菜单')"
            label="小程序ID："
          >
            <el-input
              clearable
              v-model="form.miniprogram_appid"
              placeholder="请输入小程序appId"
            ></el-input>
          </el-form-item>
          <el-form-item prop="miniprogram_pagepath" v-if="checkList.includes('小程序菜单')" label="页面路径：">
            <el-input clearable v-model="form.miniprogram_pagepath" placeholder="请输入点击后进入的小程序页面路径"></el-input>
          </el-form-item>
          <el-form-item prop="miniprogram_content" v-if="checkList.includes('小程序菜单')" label="小程序菜单：">
            <el-input clearable v-model="form.miniprogram_content" placeholder="请输入小程序菜单内容"></el-input>
          </el-form-item>
        </div>
        <div class="form-footer">
          <el-form-item label-width="2.5rem">
            <el-button v-if="this.$route.query.id" type="primary" @click="submitForm('ruleForm')">确定编辑</el-button>
            <el-button v-else type="primary" @click="submitForm('ruleForm')">立即创建</el-button>
            <!-- <el-button style="margin-left: 2.0rem" plain @click="$router.back()"
              >取消</el-button
            > -->
          </el-form-item>
        </div>
      </el-form>
    </div>
    <right-people ref="dialog" :checkbox="checkbox" @handleSelect="handleSelect"></right-people>
  </div>
</template>
<script>
import axios from "axios";
import qs from "qs";
import rightPeople from '@/components/drawer/rightPeople';
export default {
  components: {
    rightPeople
  },
  data() {
    return {
      form: {
        scope: 1,
        type: "文本消息",
        menu_type: "", //选择菜单以后的选择类型
        content: "",
        click_content: "",
        view_url: "",
        view_content: "",
        miniprogram_appid: "",
        miniprogram_pagepath: "/pages/page/index.html",
        miniprogram_content: "",
        open_kfid: "", //客服账号
      },
      checkList: [],
      rules: {
        content: [
          { required: true, message: "请输入欢迎语内容", trigger: 'blur'},
        ],
        type: [{ required: true, message: "请选择发送类型", trigger: "blur" }],
        menu_type: [
          { required: true, message: "请选择菜单类型", trigger: "blur" },
        ],
        click_content: [
          { required: true, message: "请输入回复内容", trigger: "blur" },
        ],
        view_url: [
          { required: true, message: "请输入超链接", trigger: "blur" },
        ],
        view_content: [
          { required: true, message: "请输入超链接菜单内容", trigger: "blur" },
        ],
        miniprogram_appid: [
          { required: true, message: "请输入小程序appId", trigger: "blur" },
        ],
        miniprogram_pagepath: [
          {
            required: true,
            message: "请输入点击后进入的小程序页面路径",
            trigger: "blur",
          },
        ],
        miniprogram_content: [
          { required: true, message: "请输入小程序菜单内容", trigger: "blur" },
        ],
      },
      tooken: "",
      checkbox: false,
      names: [],
      module: "",
      subType: "", //提交给后端处理过的type
      menuType: [], //提交给后端的菜单类型
      selectionDepartment: false,
      selectionName: false,
      title: "",

    };
  },
  mounted() {
    if (window.localStorage.getItem("storuser")) {
      let userinfo = JSON.parse(window.localStorage.getItem("storuser"));
      this.tooken = userinfo;
    }
    if (!this.$route.query.id) {
      this.title = "新建欢迎语"
      this.form.type = "文本消息";
      return;
    } else {
      this.title = "编辑欢迎语"
    }
    this.getData();
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    getData() {
      this.axios
        .post(
          "/crm/CustomerServiceWelcome/getWelcome",
          qs.stringify({
            account_id: this.tooken.account_id,
            id: this.$route.query.id,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.code == 1) {
            const data = res.data.data.data[0];
            this.form.scope = data.scope;
            this.form.type = data.type_name;
            this.form.menu_type = data.menu_type_name;
            this.form.content = data.content;
            this.form.click_content = data.click_content;
            this.form.view_url = data.view_url;
            this.form.view_content = data.view_content;
            this.form.miniprogram_appid = data.miniprogram_appid;
            this.form.miniprogram_pagepath = data.miniprogram_pagepath;
            this.form.miniprogram_content = data.miniprogram_content;
            this.form.open_kfid = data.open_kfid;
            this.names = data.open_kfid_name.split(",");
            this.checkList = data.menu_type_name.split(",")
            this.menuType = data.menu_type;
          } else if (res.data.code == 0) {
            this.$message.error(res.data.msg);
          }
        })
        .catch(function (err) { });
    },
    changeType() {
      this.checkList = [];
    },
    changeGroup() {
      let mType = this.checkList.map((val) => {
        if (val === "回复菜单") {
          return "click";
        } else if (val === "超链接菜单") {
          return "view";
        } else {
          return "miniprogram";
        }
      });
      this.menuType = mType.join()
    },
    addContact() {
      this.module = "getCustomerServerList";
      this.checkbox = true;
      this.isGroup = true;
      this.$refs.dialog.open();
    },
    handleSelect(person) {
      switch (this.module) {
        case "getCustomerServerList":
          const open_kfid = [];
          const user = [];
          person.map((item) => {
            open_kfid.push(item.open_kfid);
            user.push(item.name);
          });
          this.form.open_kfid = open_kfid.join();
          this.names = user;
          break;
        default:
          break;
      }
    },
    changeScope(label) {
      switch (label) {
        case "1":
          Reflect.deleteProperty(this.rules, "open_kfid");
          break;
        default:
          this.rules.open_kfid = [
            {
              required: true,
              message: "请选择客服",
              trigger: "blur",
            },
          ];
          break;
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submit();
        } else {
          return false;
        }
      });
    },
    async submit() {
      if (this.form.type === "文本消息") {
        this.subType = "text";
      } else if (this.form.type === "菜单消息") {
        this.subType = "msgmenu";
      }
      const url = this.$route.query.id ? "editWelcome" : "addWelcome";
      const res = await this.axios({
        url: `/crm/CustomerServiceWelcome/${url}`,
        method: "POST",
        data: {
          account_id: this.tooken.account_id,
          id: this.$route.query.id,
          scope: this.form.scope,
          type: this.subType,
          menu_type: this.menuType,
          content: this.form.content,
          click_content: this.form.click_content,
          view_url: this.form.view_url,
          view_content: this.form.view_content,
          miniprogram_appid: this.form.miniprogram_appid,
          miniprogram_pagepath: this.form.miniprogram_pagepath,
          miniprogram_content: this.form.miniprogram_content,
          open_kfid: this.form.open_kfid,
        },
      });
      if (res.data.code == 1) {
        this.$message.success(res.data.msg);
        this.$router.go(-1);
      } else if (res.data.code == 0) {
        this.$message.error(res.data.msg);
      }
    },
  },
};
</script>
<style scoped>
.header {
  line-height: 4rem;
  border-bottom: .1rem solid rgb(241, 239, 239);
}



.main {
  /* margin-top: 4.0rem; */
  background-color: #fff ;

  border-radius: .8rem;
  padding: 4.0rem 2.0rem;
}

.form-header {

  padding-right: 2.2rem;
  overflow: hidden;
}

.form-footer {
  padding-top: 5rem;
}

.el-upload-list__item-thumbnail {
  width: 10rem;
  height: 10rem;
}
.el-form-item {
    margin-bottom: 4rem;
}
.el-input,.el-textarea{
  width: 47rem;
}
</style>
